export enum UnitOfMeasure {
  KG = 'KG',
  G = 'G',
  M = 'M',
  MM = 'MM',
  UNRECOGNISED = 'UNRECOGNISED',
}
